import { Tooltip, TooltipProps } from "antd"

function CustomTooltip(props: TooltipProps) {
  const { className, children, ...restProps } = props
  return (
    <Tooltip overlayClassName={className} {...restProps}>
      {children}
    </Tooltip>
  )
}

export default CustomTooltip
